'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('widgetProjectComments', widgetProjectComments);

  function widgetProjectComments () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/comments/widget-project-comments.tmpl.html',
      controller: 'widgetProjectCommentsCtrl',
      controllerAs: '$widgetProjectCommentsCtrl',
      scope: true,
    };
  }
})();
